<template>
    <div class="deliver-form">
        <div class="filters">
            <app-sub-title text="Filtros" />
            <div class="card">
                <div class="card-body">
                    <div class="card-text">
                        <b-row>
                            <b-col cols="12" lg="4">
                                <app-form-select-input
                                    label="Tipo"
                                    :options="mailTypes"
                                    v-model="filters.type"
                                />
                            </b-col>
                            <b-col cols="12" lg="4">
                                <app-autocomplete
                                    label="Destino"
                                    :items="structures"
                                    v-model="selectedStructure"
                                />
                                <!-- <app-form-text-input label="Destino" v-model="filters.destination" /> -->
                            </b-col>
                            <b-col cols="12" lg="4">
                                <app-form-text-input
                                    label="Para"
                                    v-model="filters.owner"
                                />
                            </b-col>

                            <b-col cols="12" lg="1" offset-lg="10">
                                <b-btn
                                    @click="searchMails"
                                    variant="primary"
                                    class="btn-block"
                                >
                                    <i class="fa fa-filter"></i>
                                </b-btn>
                            </b-col>
                            <b-col cols="12" lg="1">
                                <b-btn
                                    @click="cancelFilter"
                                    variant="secondary"
                                    class="btn-block"
                                >
                                    <i class="fa fa-times-circle"></i>
                                </b-btn>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="alert alert-success" v-if="!theMails.length">
                ¡No hay datos!
            </div>
        </div>
        <b-row class="mt-2">
            <b-col cols="12" lg="4">
                <b-button
                    block
                    size="sm"
                    :disabled="!mailsSelected"
                    variant="primary"
                    @click="deliverMail"
                    >Entregar</b-button
                >
            </b-col>
            <b-col cols="12" lg="4">
                <b-button
                    block
                    size="sm"
                    variant="outline-primary"
                    @click="exportMails"
                    :disabled="!clientId && !client"
                >
                    <i class="fa fa-download" aria-hidden="true"></i> Exportar
                </b-button>
            </b-col>
        </b-row>
        <div v-if="mailsLoading">
            <b-row align-h="center">
                <b-col cols="auto"
                    ><img src="images/loadergif.gif" alt=""
                /></b-col>
            </b-row>
        </div>
        <div v-else>
            <app-table-deliver
                :data="data"
                :view-mail="seeMore"
                :deliver-mail="deliverMail"
                :onChangePage="onChangePage"
                @sort="onSort"
                :disable-delivery="disableDelivery"
                @keys="onSelectedKeys"
                ref="mails-table"
            />
        </div>

        <!-- inicio de pop ups -->

        <!-- <app-pop-up id="deliver-window" title="Entregar Correspondencia" :onShowUp="resizeSignaturePad" :onClose="cleanForm"> -->
        <app-pop-up
            id="deliver-window"
            title="Entregar Correspondencia"
            :onClose="cleanForm"
            v-if="!!destination"
        >
            <div slot="body">
                <div class="mail">
                    <h5>Destino: {{ destination.name }}</h5>
                </div>
                <b-row>
                    <b-col cols="12">
                        <app-form-textarea-input
                            label="Notas"
                            id="delivery-notes"
                            v-model="delivery.notes"
                        ></app-form-textarea-input>
                    </b-col>
                    <b-col cols="12">
                        <app-form-text-input
                            label="Entregado a"
                            id="name"
                            v-model="delivery.deliveredTo"
                            :required="true"
                            :hasError="$v.delivery.deliveredTo.$error"
                            errorMessage="Debe escribir el nombre de quien recibe la correspondencia"
                            @input="$v.delivery.deliveredTo.$touch()"
                        />
                    </b-col>
                    <b-col cols="12">
                        <img
                            :src="delivery.firm"
                            v-if="!!delivery.firm"
                            alt=""
                        />
                        <b-btn block variant="primary" @click="openSignaturePad"
                            >Firmar</b-btn
                        >
                    </b-col>
                    <div
                        class="signature-pad"
                        id="signature-pad"
                        v-if="isGettingSignature"
                        :style="{ width, height }"
                    >
                        <b-row
                            class="pt-3"
                            :style="{ 'background-color': 'white' }"
                        >
                            <b-col cols="8">
                                <h3>Recopilación de firma digital</h3>
                            </b-col>
                            <b-col cols="2">
                                <b-btn
                                    variant="confirm"
                                    @click="saveSignature"
                                    block
                                    >Aceptar</b-btn
                                >
                            </b-col>
                            <b-col cols="2">
                                <b-btn
                                    variant="danger"
                                    @click="isGettingSignature = false"
                                    block
                                    >Cancelar</b-btn
                                >
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <app-vue-signature
                                    id="signature"
                                    :width="width"
                                    :height="height"
                                    ref="signaturePad"
                                />
                            </b-col>
                        </b-row>
                    </div>
                </b-row>
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="save"
                >
                    <i class="fa fa-save"></i> Entregar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up id="view-email-more-deliver" title="Correspondencia">
            <div slot="body">
                <app-mail-card v-if="selectedMail" :mail="selectedMail" />
            </div>
        </app-pop-up>

        <!-- fin de pop ups -->
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import TableDeliver from './TableDeliver/TableDeliver.vue'
import MailCard from '../../MailCard/MailCard.vue'
import vigilanceRepository from '../../../../../repositories/vigilance.repository'
import VueSignature from 'vue-signature-pad'
import { required } from 'vuelidate/lib/validators'
import { resize } from '../../../../../utils/ImageTools'

export default {
    components: {
        appTableDeliver: TableDeliver,
        appVueSignature: VueSignature,
        appMailCard: MailCard,
    },
    props: {
        clientId: {
            type: Number,
            default: 0,
        },
        venueId: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            mailsLoading: true,
            page: 1,
            delivery: {
                notes: '',
                mailId: '',
                deliveredTo: '',
                firm: '',
            },
            selectedMail: '',
            theMails: [],
            data: {},
            filters: {
                destination: '',
                owner: '',
                type: '',
            },
            slide: 1,
            sort: {
                sortBy: 'created_at',
                sortDir: 'asc',
            },
            width: 0,
            height: 0,
            isGettingSignature: false,
            signatureData: '',
            selectedStructure: '',
            keys: '',
            mails: [],
            enableSendPopup: false,
            destination: '',
            owner: '',
            structures: [],
        }
    },
    validations: {
        delivery: {
            deliveredTo: { required },
        },
    },
    watch: {
        selectedStructure() {
            if (this.selectedStructure == null) {
                this.cancelFilter()
            } else {
                this.filters.destination = this.selectedStructure.id
                this.page = 1
                this.loadMails()
            }
        },
        accessPoint(val) {
            if (!val) return

            this.loadStructures()
            this.loadMails()
        },
    },
    computed: {
        ...mapGetters(['mailTypes']),
        disableDelivery() {
            return this.clientId !== 0
        },
        mailsSelected() {
            return !!this.keys.length
        },
    },
    methods: {
        ...mapActions(['saveMailDelivery']),
        async onSelectedKeys(keys) {
            if (!keys.length) {
                this.keys = []
                return this.loadMails()
            }

            this.keys = _.uniq(keys)

            // this.destination = this.theMails[0].destination
            this.destination = this.theMails.find(
                (item) => item.id === keys[0]
            ).destination

            if (keys.length > 1) return

            const destination = keys[0]
            const { data } = await repo.get(
                `mail/${destination}/structure-mails`,
                {
                    page: 1,
                    delivered: 'yes',
                }
            )
            this.data = data
            this.theMails = data.data
        },
        clear() {
            this.data = {}
            this.theMails = []
        },
        deliverMail() {
            if (!this.keys.length)
                return toastr.error(
                    'Debe seleccionar al menos una correspondencia'
                )

            this.$bus.$emit('deliver-window.open')
        },
        async save() {
            this.$v.$touch()
            if (this.$v.delivery.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            // const { data } = this.$refs.signaturePad.saveSignature();
            // if(data){
            //     this.delivery.firm = data;
            // }

            const formData = new FormData()

            formData.append('notes', this.delivery.notes)
            if (this.keys) {
                this.keys.map((item) => formData.append('mailIds[]', item))
            }
            formData.append('deliveredTo', this.delivery.deliveredTo)

            if (this.delivery.firm) {
                formData.append('firm', this.delivery.firm)
            }

            const { data } = await repo.post('mail/deliver', formData)

            if (data.status) {
                toastr.success('La correspondencia fue entregada con exito')
                this.reset()
            } else {
                toastr.error(data.msg)
            }
        },
        reset() {
            this.$v.$reset()
            Object.keys(this.delivery).map((key) => (this.delivery[key] = ''))
            this.$bus.$emit('deliver-window.close')
            this.loadMails()
            this.loadDeliveredMails()
            this.selectedMail = ''
            this.filters.destination = ''
            this.filters.type = ''
            this.filters.owner = ''
            this.btnSendMail = false
            this.keys = []
            this.$refs['mails-table'].selectNone()
            this.page = 1
        },
        cleanForm() {
            this.delivery.notes = ''
            this.file = ''
            this.isGettingSignature = false
        },
        seeMore(item) {
            this.selectedMail = Object.assign({}, item)
            this.$bus.$emit('view-email-more-deliver.open')
        },
        loadMails() {
            const vr = Object.assign({}, vigilanceRepository)
            const filters = {
                ...this.filters,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
            }
            // si es vigilante filtrar por la sede donde esta vigilando
            if (this.user.profile.slug === 'vigilante') {
                filters.venue = this.accessPoint.venue_id
            }
            const clientId = !this.clientId
                ? !!this.client
                    ? this.client.id
                    : 0
                : this.clientId

            if (!clientId) return

            vr.getPendingMailPaged(clientId, this.page, filters)
                .then((data) => {
                    this.data = data
                    this.theMails = data.data
                    this.mailsLoading = false
                })
                .catch((error) => {
                    this.mailsLoading = false
                    toastr.error(
                        'Ocurrió un error al cargar las correspondencias'
                    )
                })
        },
        loadDeliveredMails() {
            this.$bus.$emit('delivered-mails.load')
        },
        searchMails() {
            this.page = 1
            this.loadMails()
        },
        cancelFilter() {
            this.page = 1
            Object.keys(this.filters).map((key) => (this.filters[key] = ''))
            this.loadMails()
        },
        exportMails() {
            const clientId = this.clientId || (this.client && this.client.id) || 0
            if (!clientId) {
                toastr.error('No hay cliente seleccionado')
                return
            }
            const params = {
                client: clientId,
                delivered: '0',
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
            }
            if (this.venueId) params.venue = this.venueId
            else if (this.user && this.user.profile && this.user.profile.slug === 'vigilante' && this.accessPoint) params.venue = this.accessPoint.venue_id
            if (this.filters.type) params.type = this.filters.type
            if (this.filters.destination) params.destination = this.filters.destination
            if (this.filters.owner) params.owner = this.filters.owner
            const queryString = Object.keys(params).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`).join('&')
            window.location.href = `exports/mail/export-excel?${queryString}`
        },
        onChangePage(page) {
            this.page = page
            this.loadMails()
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy
            this.sort.sortDir = ctx.sortDir
            this.loadMails()
        },
        undo() {
            this.$refs.signaturePad.undoSignature()
        },
        resizeSignaturePad() {
            this.$nextTick(function () {
                this.$refs.signaturePad.resizeCanvas()
            })
        },
        maximizeSignaturePad() {
            this.resizeSignaturePad()
        },
        setSignaturePadSize() {
            this.width = `100%`
            this.height = `100%`
        },
        openSignaturePad() {
            this.isGettingSignature = true

            this.$nextTick(() => {
                $('#signature-pad').position({ top: 0, left: 0 })
            })
            this.resizeSignaturePad()
        },
        saveSignature() {
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
            if (isEmpty) return

            const image = new Image()
            image.src = data
            const img = image.addEventListener('load', (e) => {
                this.delivery.firm = resize(e.target, { height: 200 })
                this.isGettingSignature = false
            })
        },
        async loadStructures() {
            const venueId = !!this.accessPoint
                ? this.accessPoint.venue_id
                : !!this.venueId
                ? this.venueId
                : 0

            if (!venueId) return
            const { data } = await repo.get('structures', {
                venue: venueId,
            })
            this.structures = data
        },
    },
    created() {
        this.loadMails()
        this.load('mailTypes')
        this.loadStructures()
        this.$bus.$on('mail-list.refresh', this.loadMails)
    },
    mounted() {
        this.setSignaturePadSize()
    },
}
</script>
<style>
#signature {
    border: double 3px transparent;
    border-radius: 5px;
    background-image: linear-gradient(white, white),
        radial-gradient(circle at top left, #4bc5e8, #9f6274);
    background-origin: border-box;
    background-clip: content-box, border-box;
}

.signature-pad {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
}
</style>
